// material-ui
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

// project import
import NavGroup from './NavGroup';
import { useDispatch, useSelector } from 'react-redux';
import getMenuItems from '../../../../../menu-items';
import { Avatar } from '@mui/material';
import { useMediaQuery } from '@mui/system';
import { useGetMenuMaster } from "api/menu"

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

export default function Navigation() {
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  const { profileData = null } = useSelector((state) => state.auth)

  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;

  const menu = getMenuItems(profileData?.permissions)

  const navGroups = menu?.items?.map((item) => {
    switch (item.type) {
      case 'group':
        return <NavGroup key={item.id} item={item} />;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Fix - Navigation Group
          </Typography>
        );
    }
  });

  return (
    <Box sx={{ pt: 2 }}>
      {/******* here you can add avatar *********/}
      {
        drawerOpen
          ?
          <Box sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            mb: 5
          }}>
            <Avatar
              src={`${import.meta.env.VITE_IMAGE_URL}${profileData?.avatar}` || ""}
              sx={{ height: 120, width: 120 }}
            >
              {profileData?.name?.[0] || "A"}
            </Avatar>
            <Typography sx={{ fontSize: "20px", fontWeight: 700, pt: 1 }}>{profileData?.name}</Typography>
          </Box>
          :
          <Box sx={{
            display: "flex",
            justifyContent: "center",
            mb: 5
          }}>
            <Avatar
              src={`${import.meta.env.VITE_IMAGE_URL}${profileData?.avatar}` || ""}
              sx={{ height: 45, width: 45, border: "1px solid gray" }}
            >
              {profileData?.name?.[0] || "A"}
            </Avatar>
          </Box>
      }
      <Box>
        {navGroups}
      </Box>
    </Box>);
}
